import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSpacePagepageNews from "../../components/Insulated/ViewInsulatedLayer";



const ViewInsulated= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Insulated" title2="Insulated" link2="/insulated" />

        {/* AddUserLayer */}
        <ViewSpacePagepageNews />


      </MasterLayout>
    </>
  );
};

export default ViewInsulated;
